import * as React from 'react';

import { IconButton } from '~shared/components/buttons';
import { DialogTitle } from '~shared/components/Dialog';
import { IconArrow } from '~shared/components/icons/large';
import { Stack } from '~shared/components/Stack';

interface Props {
  onBack?: () => void;
  icon: React.ReactElement;
  title: string;
  message: string;
  children?: React.ReactElement;
}

export const EmailStudentsFeedback = React.forwardRef<HTMLElement, Props>(
  function EmailStudentsFeedback(
    { onBack, icon, title, message, children }: Props,
    ref
  ) {
    return (
      <>
        {onBack && (
          <div className="absolute top-0 left-0 p-6">
            <IconButton appearance="ghost" onClick={() => onBack()}>
              <IconArrow direction="left" />
            </IconButton>
          </div>
        )}
        <div className="flex items-center justify-center w-full h-full p-4 sm:p-8">
          <div className="text-center">
            <Stack space="8">
              {icon}
              <Stack space="4">
                <h3 className="m-0">
                  <DialogTitle ref={ref}>{title}</DialogTitle>
                </h3>
                <p className="m-0 font-sans text-base leading-8 text-blue-900">
                  {message}
                </p>
              </Stack>
              {children}
            </Stack>
          </div>
        </div>
      </>
    );
  }
);
